import { Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';

import { AutoComplete } from 'primeng/autocomplete';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { QuestaoFilter } from 'src/app/questionario/questao/model/questao.filter';
import { Questao } from 'src/app/questionario/questao/model/questao.model';
import { QuestaoService } from 'src/app/questionario/questao/questao.service';
import { environment } from 'src/environments/environment';
import { Status } from '../../framework/default.model';
import { AutocompleteComponent } from '../../framework/input-components/autocomplete-component.abstract';
import { ListaResultset } from '../../list/lista-resultset.interface';


@Component({
  selector: 'app-autocomplete-questao',
  templateUrl: './autocomplete-questao.component.html',
  styleUrls: ['./autocomplete-questao.component.css']
})
export class AutocompleteQuestaoComponent extends AutocompleteComponent<Questao> implements OnInit, OnDestroy {
  
  @Input() obrigatorio = false;
  @Input() placeholder = 'Questão';
  @Input() bloqueado   = false;

  @ViewChild('autocomplete') autocompleteViewChild: AutoComplete;

  formDisabled = false;
  autocompleteName = 'questao';

  itemSelecionado: Questao;
  resultset: Questao[];
  resultsetMaxSize = environment.localizador_max_size;

  private subject: Subject<Questao>;

  constructor(
    private questaoService: QuestaoService,
    private changeDetectorRef?: ChangeDetectorRef
  ) {
    super();

    this.subject = new Subject();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if ( this.subject ) {
      this.subject.complete();
    }    
  }


  getObjetoSelecionado(): Questao {
    return this.itemSelecionado;
  }

  setObjetoSelecionado(o: Questao): void {
    this.itemSelecionado = o;
  }

  getSubject(): Subject<Questao> {
    return this.subject;
  }

  search(event: any): void {
    const filter: QuestaoFilter = {
      status: Status.ATIVO,
      nome: event.query
    };

    this.questaoService
        .listar(filter)
        .pipe(
          map((response: ListaResultset<Questao>) => {
            response
              .content
              .forEach(o => o.nome = `(#${o.id}) ${o.nome}`);

            return response;
          })
        )
        .subscribe((response: ListaResultset<Questao>) => {
          this.resultset = response.content;
        });
  }

  focus(): void {
    if ( this.autocompleteViewChild ) {
      this.autocompleteViewChild.focusInput();
    }    
  }

  onBlur(event): void {
    if ( this.changeDetectorRef ) {
      this.changeDetectorRef.detectChanges();
    }
  }

}
